export default "__VITE_ASSET__SwbPtI1N__"